<!-- defined 定制表单 -->
<template>
  <div class="preSale" :id="`extended-attrs-${elKey}`" v-if="data[`${$route.params.tableName}_formConfig`]">
    <div :key="`${$route.params.tableName}_formConfig`" v-loading="data[`${$route.params.tableName}_formConfig`].loading">
      <OmsForm :form-config="data[`${$route.params.tableName}_formConfig`]" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'extendedAttrs',
  data() {
    return {
      ID: this.$route.params.itemId && this.$route.params.itemId != 'New' ? this.$route.params.itemId : '-1', // 记录主界面传入的ID
      tableName: this.$route.params.tableName,
      modifyData: {},
      relationCode: '',
      configTables: [
        'CP_C_SHOP', 'PS_C_PRO', 'PS_C_SKU', 'CP_C_CUSTOMER','CP_C_RSTORE',
        'CP_C_WAREHOUSE', 'CP_C_SUPPLIER'
      ],
      data: {}, // 表单数据
    };
  },
  created() {
    const init = {
      formData: [],
      formValue: {},
      isGrid: true,
      loading: false,
      iconSite: 'rightTop',
      flodClick: true,
      setColnum: 4, // 4列
      setRow: 2 // 2行
    }
    const formKey = `${this.tableName}_formConfig`
    this.$set(this.data, formKey, init)
  },
  mounted() {
    sessionStorage.removeItem('cpCShop_isUpdate');
    sessionStorage.removeItem('cpCShop_form');
    window.addEventListener('resize', this.pageStyle, false);
    window.addEventListener('customizeClick', this.Save);
    this.pageStyle();
    if (!['PS_C_PRO', 'PS_C_SKU'].includes(this.tableName)) {
      // 除了这两个页面（监听对应字段调接口），其他是初始时调接口
      this.init();
    }
  },
  activated() {
    this.pageStyle();
  },
  watch: {
    commodityCategoryId: {
      handler(val) {
        // 商品SPU单对象-监听商品品类
        if (this.tableName == 'PS_C_PRO') this.init();
      },
      immediate: true,
    },
    relationId: {
      handler(val) {
        // 商品SKU单对象-监听主表的SPU编码
        if (this.tableName == 'PS_C_SKU') this.init();
      },
    },
  },
  computed: {
    ...mapState('customize', ['commodityCategoryId', 'relationId']),
    elKey() {
      return Object.values(this.$route.params).join('-')
    }
  },
  methods: {
    ...mapMutations('customize', ['setCommodityCategoryId', 'setRelationId']),
    pageStyle() {
      //先清理页面
      setTimeout(() => {
        $('.preSale').parent().parent().find('.itemLabel').remove();
        $(`.ark-collapse[data-name="${this.$parent.$parent.$parent.$parent.name}"] .content.R3masterForm`).attr('style', '');
      }, 1000);
    },
    init() {
      if (!this.configTables.includes(this.tableName)) return;
      if (this.tableName == 'PS_C_PRO' && !this.commodityCategoryId) {
        return;
      }
      if (this.tableName == 'PS_C_SKU' && !this.relationId && !this.relationCode) {
        return;
      }
      let api = '';
      const params = {
        id: this.ID,
      };
      const getCopyId = () => {
        if (params.id == -1) {
          const copyId = sessionStorage.getItem(`${this.tableName}_definedForm_copy_itemId`)
          if (!!copyId) {
            params.id = copyId
          }
        }
      }
      getCopyId() // 获取复制单对象id
      switch (this.tableName) {
        case 'CP_C_CUSTOMER': // 客户档案
          api = 'getExtendInfoForCustomer'
          break;
        case 'CP_C_RSTORE': // 门店档案
        case 'CP_C_WAREHOUSE': // 逻辑仓档案
          api = 'getExtendInfoForStoredim'
          params.tableName = this.tableName
          break;
        case 'CP_C_SUPPLIER': // 供应商档案
          api = 'getExtendInfoForSuppdim'
          break;
        case 'CP_C_SHOP': // 平台店铺档案
          api = 'getExtendInfo'
          break;
        case 'PS_C_PRO': // 商品SPU
          api = 'getExtendInfoForGood'
          params.tableName = this.tableName
          params.relationId = this.commodityCategoryId
          break;
        case 'PS_C_SKU': // 商品SKU
          api = 'getExtendInfoForGood'
          params.tableName = this.tableName
          params.relationId = -1
          params.relationCode = this.relationId
          break;
        default:
          break;
      }
      this.initForm({ api, params });
    },
    async initForm({ api, params }) {
      const formKey = `${this.tableName}_formConfig`
      if (!this.data.hasOwnProperty(formKey)) return; // 存在当前表单配置是上个页面，故作此判断
      this.data[formKey].loading = true
      const {
        data: { code, data },
      } = await this.service.commodityCenter[api](params)
      if (code != 0) return;
      if (!data) {
        this.data[formKey].loading = false
        return;
      }
      const formData = [];
      data.forEach((item, index) => {
        switch (item.type) {
          case 'datetime':
            formData[index] = {
              style: 'date', // 输入框类型
              type: 'datetime', // 文本框类型的input
              label: item.label, // 输入框前文字
              value: item.name, // 输入框的值
              format: 'yyyy-MM-dd HH:mm:ss',
              width: '6', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
              onChange: () => {
                const v = this.data[formKey].formValue[item.name];
                this.data[formKey].formValue[item.name] = v ? $utils.standardTimeConversiondateToStr(v) : '';
                this.setModifyData(item.name);
              },
            };
            break;
          case 'text':
            formData[index] = {
              style: 'input', // 输入框类型
              label: item.label, // 输入框前文字
              value: item.name, // 输入框的值
              width: '6',
              inputblur: () => {
                this.setModifyData(item.name);
              },
            };
            break;
          case 'number':
            formData[index] = {
              style: 'input', // 输入框类型
              label: item.label, // 输入框前文字
              value: item.name, // 输入框的值
              width: '6',
              regx: /^\d+(\.\d{0,2})?$/,
              inputblur: () => {
                this.setModifyData(item.name);
              },
            };
            break;
          case 'select':
            if (vm.$route.params.tableName == 'PS_C_SKU') {
              formData[index] = {
                style: 'dropSelect', // 输入框弹框单多选
                width: '6',
                class: 'extendedAttrs_drp',
                label: item.label, // input前面显示的lable值
                itemdata: {
                  colid: 1700857464,
                  colname: item.name, // 当前字段的名称
                  datelimit: 'all',
                  display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
                  fkdisplay: 'drp', // 外键关联类型
                  isfk: true, // 是否有fk键
                  name: item.label, // input前面显示的lable值
                  readonly: false, // 是否可编辑，对应input   readonly属性
                  reftable: 'CP_C_SPU_SKU_EXTEND_INFO',
                  pid: item.value,
                  valuedata: item.valuedata, // 这个是选择的值
                  filterConds: [
                    { fixcolumn: 'PS_C_SPECGROUP_ID', refobjid: item.id },
                  ]
                },
                oneObj: (e) => {
                  const formKey = `${this.tableName}_formConfig`
                  this.data[formKey].formValue[item.name] = e.pid;
                  this.setModifyData(item.name);
                },
              };
              if (this.ID != -1 && formData[index].itemdata.valuedata) {
                formData[index].itemdata.readonly = true;
              }
              break;
            }
            if (item.dictionaryList && item.dictionaryList.length > 1000) {
              // 数据超级多（好几千甚至大于1w），页面渲染直接挂掉
              formData[index] = {
                style: 'input', // 输入框类型
                label: item.label, // 输入框前文字
                value: item.name, // 输入框的值 暂时的
                width: '6',
                inputblur: () => {
                  this.setModifyData(item.name);
                },
              };
            } else {
              formData[index] = {
                style: 'select', // 下拉框类型
                label: item.label, // 下拉框前的值
                width: '6', // 所占宽度宽度
                clearable: true, // 是否显示下来清空按钮
                value: item.name, // 输入框的值
                multiple: false, // 布尔值,下拉框是否开启多选,默认为不开启
                options: item.dictionaryList,
                selectChange: () => {
                  this.setModifyData(item.name);
                }, // 选中事件，默认返回选中的值
                clearSelect: (e) => {
                  this.setModifyData(item.name);
                }, // 点击清空按钮回调
              };
            }
            break;
        }
        if (item.type == 'datetime') {
          this.data[formKey].formValue[item.name] = item.value ? $utils.standardTimeConversiondateToStr(item.value) : '';
        } else if (['select'].includes(item.type)) {
          this.data[formKey].formValue[item.name] = item.value ? Number(item.value) : '';
        } else {
          this.data[formKey].formValue[item.name] = item.value || '';
        }
        if (this.tableName == 'PS_C_SKU' && this.ID != -1 && this.data[formKey].formValue[item.name]) {
          formData[index].disabled = true;
        }
      });
      this.data[formKey].formData = formData;
      this.modifyData = {};
      setTimeout(() => {
        this.data[formKey].loading = false
      }, 100);
    },
    setModifyData(name) {
      const formKey = `${this.tableName}_formConfig`
      const v = this.data[formKey].formValue[name];
      this.modifyData[name] = v;
    },
    getFormData() {
      const formKey = `${this.tableName}_formConfig`
      const form = this.data[formKey].formValue;
      let result = [];
      switch (this.tableName) {
        case 'CP_C_SHOP': // 平台店铺档案
        case 'CP_C_CUSTOMER': // 客户档案
        case 'CP_C_RSTORE': // 门店档案
        case 'CP_C_WAREHOUSE': // 逻辑仓档案
        case 'CP_C_SUPPLIER': // 供应商档案
        case 'PS_C_PRO': // 商品SPU
        case 'PS_C_SKU': // 商品SKU
          for (let key in form) {
            const data = {
              column_name: key,
              column_value: form[key] || '', // 避免undefined被接口delete掉
            };
            const obj = $utils.queryForm(this.data[formKey], key);
            data.label = obj.label;
            data.select_label = ''
            if (form[key]) {
              if (obj.style == 'select') {
                data.select_label = obj.options.find((i) => i.value == form[key]).label
              } else if (obj.style == 'dropSelect') {
                data.select_label = obj.itemdata.valuedata
              }
            }
            result.push(data);
          }
          break;
        default:
          break;
      }
      /* const arr = []
      if (this.tableName == 'PS_C_SKU' && this.ID == -1) {
        result.forEach(i => {
          if (!i.select_label) {
            arr.push(i.label)
          }
        })
      }
      if (arr.length) {
        return arr.join(',')
      } */
      return result;
    },
    /**
     * @param {any} e 框架封装参数
     * @param {any} callBackObjId 复制保存成功后的id
     */
    Save(e, callBackObjId) {
      if (this.tableName != this.$route.params.tableName) return // 导致其它表被保存
      const cb = (ID) => {
        let api = '';
        const params = {
          ID,
          data: [],
        };
        switch (this.tableName) {
          case 'CP_C_CUSTOMER': // 客户档案
            api = 'saveExtendInfoForCustomer'
            break;
          case 'CP_C_RSTORE': // 门店档案
          case 'CP_C_WAREHOUSE': // 逻辑仓档案
            api = 'saveExtendInfoForStoredim'
            break;
          case 'CP_C_SUPPLIER': // 供应商档案
            api = 'saveExtendInfoForSuppdim'
            break;
          case 'CP_C_SHOP': // 平台店铺档案
            api = 'saveExtendInfo';
            break;
          case 'PS_C_PRO': // 商品SPU
          case 'PS_C_SKU': // 商品SKU
            api = 'saveExtendInfoForGoods';
            break;
          default:
            break;
        }
        params.tableName = this.tableName;
        params.data = this.getFormData();

        vm.service.commodityCenter[api](params).then((res) => {
          if (res.data.code == 0) {
            const isUpdate = sessionStorage.getItem('cpCShop_isUpdate'); // 标准表单是否更新
            if (isUpdate == null || isUpdate != 'true') {
              this.$Message.success(res.data.message);
              const loadingName = this.$route.meta.moduleName.replace(/\./g, '-');
              this.$R3loading.show(loadingName);
              setTimeout(() => this.$R3loading.hide(loadingName), 300);
            }
          }
        });
      }
      if (e && e.detail.type == 'save') {
        let isModify = Object.keys(this.modifyData).length; // 定制表单是否更新
        sessionStorage.setItem('cpCShop_form', JSON.stringify(this.getFormData()));
        if (this.ID != -1 && isModify) {
          // 触发监听保存子表
          cb(this.ID)
        }
      } else {
        cb(callBackObjId)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageStyle, false);
    window.removeEventListener('customizeClick', this.Save);
    switch (this.tableName) {
      case 'PS_C_PRO': // 商品SPU
        R3.store.commit('customize/setCommodityCategoryId', '');
        break;
      case 'PS_C_SKU': // 商品SKU
        R3.store.commit('customize/setRelationId', '');
        break;
    }
  },
};
</script>

<style lang="less" scoped>
.preSale {
  min-width: 70vw;
  min-height: 5vh;
  .business-form-main {
    border: none !important;
    padding: 0;
    .cusForm-content {
      padding: 0;
    }
  }
  /deep/ .ark-form-item {
    padding-top: 4px !important;
    .ark-form-item-label {
      width: 120px !important;
    }
    .ark-form-item-content {
      line-height: 30px !important;
      margin-left: 120px !important;
    }
    &.extendedAttrs_drp {
      .ark-fkrp-select-icon {
        top: 4px;
      }
    }
  }
}
</style>
